export const LANGHAM_COUNTRIES = [
			    {
			      "name": "Afghanistan",
			      "ISD_code": "93",
			      "code": "AF"
			    },
			    {
			      "name": "Aland Islands",
			      "ISD_code": "358",
			      "code": "AX"
			    },
			    {
			      "name": "Albania",
			      "ISD_code": "355",
			      "code": "AL"
			    },
			    {
			      "name": "Algeria",
			      "ISD_code": "213",
			      "code": "DZ"
			    },
			    {
			      "name": "AmericanSamoa",
			      "ISD_code": "1684",
			      "code": "AS"
			    },
			    {
			      "name": "Andorra",
			      "ISD_code": "376",
			      "code": "AD"
			    },
			    {
			      "name": "Angola",
			      "ISD_code": "244",
			      "code": "AO"
			    },
			    {
			      "name": "Anguilla",
			      "ISD_code": "1264",
			      "code": "AI"
			    },
			    {
			      "name": "Antarctica",
			      "ISD_code": "672",
			      "code": "AQ"
			    },
			    {
			      "name": "Antigua and Barbuda",
			      "ISD_code": "1268",
			      "code": "AG"
			    },
			    {
			      "name": "Argentina",
			      "ISD_code": "54",
			      "code": "AR"
			    },
			    {
			      "name": "Armenia",
			      "ISD_code": "374",
			      "code": "AM"
			    },
			    {
			      "name": "Aruba",
			      "ISD_code": "297",
			      "code": "AW"
			    },
			    {
			      "name": "Australia",
			      "ISD_code": "61",
			      "code": "AU"
			    },
			    {
			      "name": "Austria",
			      "ISD_code": "43",
			      "code": "AT"
			    },
			    {
			      "name": "Azerbaijan",
			      "ISD_code": "994",
			      "code": "AZ"
			    },
			    {
			      "name": "Bahamas",
			      "ISD_code": "1242",
			      "code": "BS"
			    },
			    {
			      "name": "Bahrain",
			      "ISD_code": "973",
			      "code": "BH"
			    },
			    {
			      "name": "Bangladesh",
			      "ISD_code": "880",
			      "code": "BD"
			    },
			    {
			      "name": "Barbados",
			      "ISD_code": "1246",
			      "code": "BB"
			    },
			    {
			      "name": "Belarus",
			      "ISD_code": "375",
			      "code": "BY"
			    },
			    {
			      "name": "Belgium",
			      "ISD_code": "32",
			      "code": "BE"
			    },
			    {
			      "name": "Belize",
			      "ISD_code": "501",
			      "code": "BZ"
			    },
			    {
			      "name": "Benin",
			      "ISD_code": "229",
			      "code": "BJ"
			    },
			    {
			      "name": "Bermuda",
			      "ISD_code": "1441",
			      "code": "BM"
			    },
			    {
			      "name": "Bhutan",
			      "ISD_code": "975",
			      "code": "BT"
			    },
			    {
			      "name": "Bolivia, Plurinational State of",
			      "ISD_code": "591",
			      "code": "BO"
			    },
			    {
			      "name": "Bosnia and Herzegovina",
			      "ISD_code": "387",
			      "code": "BA"
			    },
			    {
			      "name": "Botswana",
			      "ISD_code": "267",
			      "code": "BW"
			    },
			    {
			      "name": "Brazil",
			      "ISD_code": "55",
			      "code": "BR"
			    },
			    {
			      "name": "British Indian Ocean Territory",
			      "ISD_code": "246",
			      "code": "IO"
			    },
			    {
			      "name": "Brunei Darussalam",
			      "ISD_code": "673",
			      "code": "BN"
			    },
			    {
			      "name": "Bulgaria",
			      "ISD_code": "359",
			      "code": "BG"
			    },
			    {
			      "name": "Burkina Faso",
			      "ISD_code": "226",
			      "code": "BF"
			    },
			    {
			      "name": "Burundi",
			      "ISD_code": "257",
			      "code": "BI"
			    },
			    {
			      "name": "Cambodia",
			      "ISD_code": "855",
			      "code": "KH"
			    },
			    {
			      "name": "Cameroon",
			      "ISD_code": "237",
			      "code": "CM"
			    },
			    {
			      "name": "Canada",
			      "ISD_code": "1",
			      "code": "CA"
			    },
			    {
			      "name": "Cape Verde",
			      "ISD_code": "238",
			      "code": "CV"
			    },
			    {
			      "name": "Cayman Islands",
			      "ISD_code": " 345",
			      "code": "KY"
			    },
			    {
			      "name": "Central African Republic",
			      "ISD_code": "236",
			      "code": "CF"
			    },
			    {
			      "name": "Chad",
			      "ISD_code": "235",
			      "code": "TD"
			    },
					{
			      "name": "Mainland China",
			      "ISD_code": "86",
			      "code": "CN"
			    },
			    {
			      "name": "Chile",
			      "ISD_code": "56",
			      "code": "CL"
			    },
			    {
			      "name": "Christmas Island",
			      "ISD_code": "61",
			      "code": "CX"
			    },
			    {
			      "name": "Cocos (Keeling) Islands",
			      "ISD_code": "61",
			      "code": "CC"
			    },
			    {
			      "name": "Colombia",
			      "ISD_code": "57",
			      "code": "CO"
			    },
			    {
			      "name": "Comoros",
			      "ISD_code": "269",
			      "code": "KM"
			    },
			    {
			      "name": "Congo",
			      "ISD_code": "242",
			      "code": "CG"
			    },
			    {
			      "name": "Congo, The Democratic Republic of the Congo",
			      "ISD_code": "243",
			      "code": "CD"
			    },
			    {
			      "name": "Cook Islands",
			      "ISD_code": "682",
			      "code": "CK"
			    },
			    {
			      "name": "Costa Rica",
			      "ISD_code": "506",
			      "code": "CR"
			    },
			    {
			      "name": "Cote d'Ivoire",
			      "ISD_code": "225",
			      "code": "CI"
			    },
			    {
			      "name": "Croatia",
			      "ISD_code": "385",
			      "code": "HR"
			    },
			    {
			      "name": "Cuba",
			      "ISD_code": "53",
			      "code": "CU"
			    },
			    {
			      "name": "Cyprus",
			      "ISD_code": "357",
			      "code": "CY"
			    },
			    {
			      "name": "Czech Republic",
			      "ISD_code": "420",
			      "code": "CZ"
			    },
			    {
			      "name": "Denmark",
			      "ISD_code": "45",
			      "code": "DK"
			    },
			    {
			      "name": "Djibouti",
			      "ISD_code": "253",
			      "code": "DJ"
			    },
			    {
			      "name": "Dominica",
			      "ISD_code": "1767",
			      "code": "DM"
			    },
			    {
			      "name": "Dominican Republic",
			      "ISD_code": "1849",
			      "code": "DO"
			    },
			    {
			      "name": "Ecuador",
			      "ISD_code": "593",
			      "code": "EC"
			    },
			    {
			      "name": "Egypt",
			      "ISD_code": "20",
			      "code": "EG"
			    },
			    {
			      "name": "El Salvador",
			      "ISD_code": "503",
			      "code": "SV"
			    },
			    {
			      "name": "Equatorial Guinea",
			      "ISD_code": "240",
			      "code": "GQ"
			    },
			    {
			      "name": "Eritrea",
			      "ISD_code": "291",
			      "code": "ER"
			    },
			    {
			      "name": "Estonia",
			      "ISD_code": "372",
			      "code": "EE"
			    },
			    {
			      "name": "Ethiopia",
			      "ISD_code": "251",
			      "code": "ET"
			    },
			    {
			      "name": "Falkland Islands (Malvinas)",
			      "ISD_code": "500",
			      "code": "FK"
			    },
			    {
			      "name": "Faroe Islands",
			      "ISD_code": "298",
			      "code": "FO"
			    },
			    {
			      "name": "Fiji",
			      "ISD_code": "679",
			      "code": "FJ"
			    },
			    {
			      "name": "Finland",
			      "ISD_code": "358",
			      "code": "FI"
			    },
			    {
			      "name": "France",
			      "ISD_code": "33",
			      "code": "FR"
			    },
			    {
			      "name": "French Guiana",
			      "ISD_code": "594",
			      "code": "GF"
			    },
			    {
			      "name": "French Polynesia",
			      "ISD_code": "689",
			      "code": "PF"
			    },
			    {
			      "name": "Gabon",
			      "ISD_code": "241",
			      "code": "GA"
			    },
			    {
			      "name": "Gambia",
			      "ISD_code": "220",
			      "code": "GM"
			    },
			    {
			      "name": "Georgia",
			      "ISD_code": "995",
			      "code": "GE"
			    },
			    {
			      "name": "Germany",
			      "ISD_code": "49",
			      "code": "DE"
			    },
			    {
			      "name": "Ghana",
			      "ISD_code": "233",
			      "code": "GH"
			    },
			    {
			      "name": "Gibraltar",
			      "ISD_code": "350",
			      "code": "GI"
			    },
			    {
			      "name": "Greece",
			      "ISD_code": "30",
			      "code": "GR"
			    },
			    {
			      "name": "Greenland",
			      "ISD_code": "299",
			      "code": "GL"
			    },
			    {
			      "name": "Grenada",
			      "ISD_code": "1473",
			      "code": "GD"
			    },
			    {
			      "name": "Guadeloupe",
			      "ISD_code": "590",
			      "code": "GP"
			    },
			    {
			      "name": "Guam",
			      "ISD_code": "1671",
			      "code": "GU"
			    },
			    {
			      "name": "Guatemala",
			      "ISD_code": "502",
			      "code": "GT"
			    },
			    {
			      "name": "Guernsey",
			      "ISD_code": "44",
			      "code": "GG"
			    },
			    {
			      "name": "Guinea",
			      "ISD_code": "224",
			      "code": "GN"
			    },
			    {
			      "name": "Guinea-Bissau",
			      "ISD_code": "245",
			      "code": "GW"
			    },
			    {
			      "name": "Guyana",
			      "ISD_code": "595",
			      "code": "GY"
			    },
			    {
			      "name": "Haiti",
			      "ISD_code": "509",
			      "code": "HT"
			    },
			    {
			      "name": "Vatican City State",
			      "ISD_code": "379",
			      "code": "VA"
			    },
			    {
			      "name": "Honduras",
			      "ISD_code": "504",
			      "code": "HN"
			    },
			    {
			      "name": "Hong Kong SAR",
			      "ISD_code": "852",
			      "code": "HK"
			    },
			    {
			      "name": "Hungary",
			      "ISD_code": "36",
			      "code": "HU"
			    },
			    {
			      "name": "Iceland",
			      "ISD_code": "354",
			      "code": "IS"
			    },
			    {
			      "name": "India",
			      "ISD_code": "91",
			      "code": "IN"
			    },
			    {
			      "name": "Indonesia",
			      "ISD_code": "62",
			      "code": "ID"
			    },
			    {
			      "name": "Iran, Islamic Republic of Persian Gulf",
			      "ISD_code": "98",
			      "code": "IR"
			    },
			    {
			      "name": "Iraq",
			      "ISD_code": "964",
			      "code": "IQ"
			    },
			    {
			      "name": "Ireland",
			      "ISD_code": "353",
			      "code": "IE"
			    },
			    {
			      "name": "Isle of Man",
			      "ISD_code": "44",
			      "code": "IM"
			    },
			    {
			      "name": "Israel",
			      "ISD_code": "972",
			      "code": "IL"
			    },
			    {
			      "name": "Italy",
			      "ISD_code": "39",
			      "code": "IT"
			    },
			    {
			      "name": "Jamaica",
			      "ISD_code": "1876",
			      "code": "JM"
			    },
			    {
			      "name": "Japan",
			      "ISD_code": "81",
			      "code": "JP"
			    },
			    {
			      "name": "Jersey",
			      "ISD_code": "44",
			      "code": "JE"
			    },
			    {
			      "name": "Jordan",
			      "ISD_code": "962",
			      "code": "JO"
			    },
			    {
			      "name": "Kazakhstan",
			      "ISD_code": "77",
			      "code": "KZ"
			    },
			    {
			      "name": "Kenya",
			      "ISD_code": "254",
			      "code": "KE"
			    },
			    {
			      "name": "Kiribati",
			      "ISD_code": "686",
			      "code": "KI"
			    },
			    {
			      "name": "Korea, Democratic People's Republic of Korea",
			      "ISD_code": "850",
			      "code": "KP"
			    },
			    {
			      "name": "Korea, Republic of South Korea",
			      "ISD_code": "82",
			      "code": "KR"
			    },
			    {
			      "name": "Kuwait",
			      "ISD_code": "965",
			      "code": "KW"
			    },
			    {
			      "name": "Kyrgyzstan",
			      "ISD_code": "996",
			      "code": "KG"
			    },
			    {
			      "name": "Laos",
			      "ISD_code": "856",
			      "code": "LA"
			    },
			    {
			      "name": "Latvia",
			      "ISD_code": "371",
			      "code": "LV"
			    },
			    {
			      "name": "Lebanon",
			      "ISD_code": "961",
			      "code": "LB"
			    },
			    {
			      "name": "Lesotho",
			      "ISD_code": "266",
			      "code": "LS"
			    },
			    {
			      "name": "Liberia",
			      "ISD_code": "231",
			      "code": "LR"
			    },
			    {
			      "name": "Libyan Arab Jamahiriya",
			      "ISD_code": "218",
			      "code": "LY"
			    },
			    {
			      "name": "Liechtenstein",
			      "ISD_code": "423",
			      "code": "LI"
			    },
			    {
			      "name": "Lithuania",
			      "ISD_code": "370",
			      "code": "LT"
			    },
			    {
			      "name": "Luxembourg",
			      "ISD_code": "352",
			      "code": "LU"
			    },
			    {
			      "name": "Macao SAR",
			      "ISD_code": "853",
			      "code": "MO"
			    },
			    {
			      "name": "Macedonia",
			      "ISD_code": "389",
			      "code": "MK"
			    },
			    {
			      "name": "Madagascar",
			      "ISD_code": "261",
			      "code": "MG"
			    },
			    {
			      "name": "Malawi",
			      "ISD_code": "265",
			      "code": "MW"
			    },
			    {
			      "name": "Malaysia",
			      "ISD_code": "60",
			      "code": "MY"
			    },
			    {
			      "name": "Maldives",
			      "ISD_code": "960",
			      "code": "MV"
			    },
			    {
			      "name": "Mali",
			      "ISD_code": "223",
			      "code": "ML"
			    },
			    {
			      "name": "Malta",
			      "ISD_code": "356",
			      "code": "MT"
			    },
			    {
			      "name": "Marshall Islands",
			      "ISD_code": "692",
			      "code": "MH"
			    },
			    {
			      "name": "Martinique",
			      "ISD_code": "596",
			      "code": "MQ"
			    },
			    {
			      "name": "Mauritania",
			      "ISD_code": "222",
			      "code": "MR"
			    },
			    {
			      "name": "Mauritius",
			      "ISD_code": "230",
			      "code": "MU"
			    },
			    {
			      "name": "Mayotte",
			      "ISD_code": "262",
			      "code": "YT"
			    },
			    {
			      "name": "Mexico",
			      "ISD_code": "52",
			      "code": "MX"
			    },
			    {
			      "name": "Micronesia, Federated States of Micronesia",
			      "ISD_code": "691",
			      "code": "FM"
			    },
			    {
			      "name": "Moldova",
			      "ISD_code": "373",
			      "code": "MD"
			    },
			    {
			      "name": "Monaco",
			      "ISD_code": "377",
			      "code": "MC"
			    },
			    {
			      "name": "Mongolia",
			      "ISD_code": "976",
			      "code": "MN"
			    },
			    {
			      "name": "Montenegro",
			      "ISD_code": "382",
			      "code": "ME"
			    },
			    {
			      "name": "Montserrat",
			      "ISD_code": "1664",
			      "code": "MS"
			    },
			    {
			      "name": "Morocco",
			      "ISD_code": "212",
			      "code": "MA"
			    },
			    {
			      "name": "Mozambique",
			      "ISD_code": "258",
			      "code": "MZ"
			    },
			    {
			      "name": "Myanmar",
			      "ISD_code": "95",
			      "code": "MM"
			    },
			    {
			      "name": "Namibia",
			      "ISD_code": "264",
			      "code": "NA"
			    },
			    {
			      "name": "Nauru",
			      "ISD_code": "674",
			      "code": "NR"
			    },
			    {
			      "name": "Nepal",
			      "ISD_code": "977",
			      "code": "NP"
			    },
			    {
			      "name": "Netherlands",
			      "ISD_code": "31",
			      "code": "NL"
			    },
			    {
			      "name": "Netherlands Antilles",
			      "ISD_code": "599",
			      "code": "AN"
			    },
			    {
			      "name": "New Caledonia",
			      "ISD_code": "687",
			      "code": "NC"
			    },
			    {
			      "name": "New Zealand",
			      "ISD_code": "64",
			      "code": "NZ"
			    },
			    {
			      "name": "Nicaragua",
			      "ISD_code": "505",
			      "code": "NI"
			    },
			    {
			      "name": "Niger",
			      "ISD_code": "227",
			      "code": "NE"
			    },
			    {
			      "name": "Nigeria",
			      "ISD_code": "234",
			      "code": "NG"
			    },
			    {
			      "name": "Niue",
			      "ISD_code": "683",
			      "code": "NU"
			    },
			    {
			      "name": "Norfolk Island",
			      "ISD_code": "672",
			      "code": "NF"
			    },
			    {
			      "name": "Northern Mariana Islands",
			      "ISD_code": "1670",
			      "code": "MP"
			    },
			    {
			      "name": "Norway",
			      "ISD_code": "47",
			      "code": "NO"
			    },
			    {
			      "name": "Oman",
			      "ISD_code": "968",
			      "code": "OM"
			    },
			    {
			      "name": "Pakistan",
			      "ISD_code": "92",
			      "code": "PK"
			    },
			    {
			      "name": "Palau",
			      "ISD_code": "680",
			      "code": "PW"
			    },
			    {
			      "name": "Palestinian Territory, Occupied",
			      "ISD_code": "970",
			      "code": "PS"
			    },
			    {
			      "name": "Panama",
			      "ISD_code": "507",
			      "code": "PA"
			    },
			    {
			      "name": "Papua New Guinea",
			      "ISD_code": "675",
			      "code": "PG"
			    },
			    {
			      "name": "Paraguay",
			      "ISD_code": "595",
			      "code": "PY"
			    },
			    {
			      "name": "Peru",
			      "ISD_code": "51",
			      "code": "PE"
			    },
			    {
			      "name": "Philippines",
			      "ISD_code": "63",
			      "code": "PH"
			    },
			    {
			      "name": "Pitcairn",
			      "ISD_code": "872",
			      "code": "PN"
			    },
			    {
			      "name": "Poland",
			      "ISD_code": "48",
			      "code": "PL"
			    },
			    {
			      "name": "Portugal",
			      "ISD_code": "351",
			      "code": "PT"
			    },
			    {
			      "name": "Puerto Rico",
			      "ISD_code": "1939",
			      "code": "PR"
			    },
			    {
			      "name": "Qatar",
			      "ISD_code": "974",
			      "code": "QA"
			    },
			    {
			      "name": "Romania",
			      "ISD_code": "40",
			      "code": "RO"
			    },
			    {
			      "name": "Russia",
			      "ISD_code": "7",
			      "code": "RU"
			    },
			    {
			      "name": "Rwanda",
			      "ISD_code": "250",
			      "code": "RW"
			    },
			    {
			      "name": "Reunion",
			      "ISD_code": "262",
			      "code": "RE"
			    },
			    {
			      "name": "Saint Barthelemy",
			      "ISD_code": "590",
			      "code": "BL"
			    },
			    {
			      "name": "Saint Helena, Ascension and Tristan Da Cunha",
			      "ISD_code": "290",
			      "code": "SH"
			    },
			    {
			      "name": "Saint Kitts and Nevis",
			      "ISD_code": "1869",
			      "code": "KN"
			    },
			    {
			      "name": "Saint Lucia",
			      "ISD_code": "1758",
			      "code": "LC"
			    },
			    {
			      "name": "Saint Martin",
			      "ISD_code": "590",
			      "code": "MF"
			    },
			    {
			      "name": "Saint Pierre and Miquelon",
			      "ISD_code": "508",
			      "code": "PM"
			    },
			    {
			      "name": "Saint Vincent and the Grenadines",
			      "ISD_code": "1784",
			      "code": "VC"
			    },
			    {
			      "name": "Samoa",
			      "ISD_code": "685",
			      "code": "WS"
			    },
			    {
			      "name": "San Marino",
			      "ISD_code": "378",
			      "code": "SM"
			    },
			    {
			      "name": "Sao Tome and Principe",
			      "ISD_code": "239",
			      "code": "ST"
			    },
			    {
			      "name": "Saudi Arabia",
			      "ISD_code": "966",
			      "code": "SA"
			    },
			    {
			      "name": "Senegal",
			      "ISD_code": "221",
			      "code": "SN"
			    },
			    {
			      "name": "Serbia",
			      "ISD_code": "381",
			      "code": "RS"
			    },
			    {
			      "name": "Seychelles",
			      "ISD_code": "248",
			      "code": "SC"
			    },
			    {
			      "name": "Sierra Leone",
			      "ISD_code": "232",
			      "code": "SL"
			    },
			    {
			      "name": "Singapore",
			      "ISD_code": "65",
			      "code": "SG"
			    },
			    {
			      "name": "Slovakia",
			      "ISD_code": "421",
			      "code": "SK"
			    },
			    {
			      "name": "Slovenia",
			      "ISD_code": "386",
			      "code": "SI"
			    },
			    {
			      "name": "Solomon Islands",
			      "ISD_code": "677",
			      "code": "SB"
			    },
			    {
			      "name": "Somalia",
			      "ISD_code": "252",
			      "code": "SO"
			    },
			    {
			      "name": "South Africa",
			      "ISD_code": "27",
			      "code": "ZA"
			    },
			    {
			      "name": "South Sudan",
			      "ISD_code": "211",
			      "code": "SS"
			    },
			    {
			      "name": "South Georgia and the South Sandwich Islands",
			      "ISD_code": "500",
			      "code": "GS"
			    },
			    {
			      "name": "Spain",
			      "ISD_code": "34",
			      "code": "ES"
			    },
			    {
			      "name": "Sri Lanka",
			      "ISD_code": "94",
			      "code": "LK"
			    },
			    {
			      "name": "Sudan",
			      "ISD_code": "249",
			      "code": "SD"
			    },
			    {
			      "name": "Suriname",
			      "ISD_code": "597",
			      "code": "SR"
			    },
			    {
			      "name": "Svalbard and Jan Mayen",
			      "ISD_code": "47",
			      "code": "SJ"
			    },
			    {
			      "name": "Swaziland",
			      "ISD_code": "268",
			      "code": "SZ"
			    },
			    {
			      "name": "Sweden",
			      "ISD_code": "46",
			      "code": "SE"
			    },
			    {
			      "name": "Switzerland",
			      "ISD_code": "41",
			      "code": "CH"
			    },
			    {
			      "name": "Syrian Arab Republic",
			      "ISD_code": "963",
			      "code": "SY"
			    },
			    {
			      "name": "Taiwan",
			      "ISD_code": "886",
			      "code": "TW"
			    },
			    {
			      "name": "Tajikistan",
			      "ISD_code": "992",
			      "code": "TJ"
			    },
			    {
			      "name": "Tanzania, United Republic of Tanzania",
			      "ISD_code": "255",
			      "code": "TZ"
			    },
			    {
			      "name": "Thailand",
			      "ISD_code": "66",
			      "code": "TH"
			    },
			    {
			      "name": "Timor-Leste",
			      "ISD_code": "670",
			      "code": "TL"
			    },
			    {
			      "name": "Togo",
			      "ISD_code": "228",
			      "code": "TG"
			    },
			    {
			      "name": "Tokelau",
			      "ISD_code": "690",
			      "code": "TK"
			    },
			    {
			      "name": "Tonga",
			      "ISD_code": "676",
			      "code": "TO"
			    },
			    {
			      "name": "Trinidad and Tobago",
			      "ISD_code": "1868",
			      "code": "TT"
			    },
			    {
			      "name": "Tunisia",
			      "ISD_code": "216",
			      "code": "TN"
			    },
			    {
			      "name": "Turkey",
			      "ISD_code": "90",
			      "code": "TR"
			    },
			    {
			      "name": "Turkmenistan",
			      "ISD_code": "993",
			      "code": "TM"
			    },
			    {
			      "name": "Turks and Caicos Islands",
			      "ISD_code": "1649",
			      "code": "TC"
			    },
			    {
			      "name": "Tuvalu",
			      "ISD_code": "688",
			      "code": "TV"
			    },
			    {
			      "name": "Uganda",
			      "ISD_code": "256",
			      "code": "UG"
			    },
			    {
			      "name": "Ukraine",
			      "ISD_code": "380",
			      "code": "UA"
			    },
			    {
			      "name": "United Arab Emirates",
			      "ISD_code": "971",
			      "code": "AE"
			    },
			    {
			      "name": "United Kingdom",
			      "ISD_code": "44",
			      "code": "GB"
			    },
			    {
			      "name": "United States",
			      "ISD_code": "1",
			      "code": "US"
			    },
			    {
			      "name": "Uruguay",
			      "ISD_code": "598",
			      "code": "UY"
			    },
			    {
			      "name": "Uzbekistan",
			      "ISD_code": "998",
			      "code": "UZ"
			    },
			    {
			      "name": "Vanuatu",
			      "ISD_code": "678",
			      "code": "VU"
			    },
			    {
			      "name": "Venezuela, Bolivarian Republic of Venezuela",
			      "ISD_code": "58",
			      "code": "VE"
			    },
			    {
			      "name": "Vietnam",
			      "ISD_code": "84",
			      "code": "VN"
			    },
			    {
			      "name": "Virgin Islands, British",
			      "ISD_code": "1284",
			      "code": "VG"
			    },
			    {
			      "name": "Virgin Islands, U.S.",
			      "ISD_code": "1340",
			      "code": "VI"
			    },
			    {
			      "name": "Wallis and Futuna",
			      "ISD_code": "681",
			      "code": "WF"
			    },
			    {
			      "name": "Yemen",
			      "ISD_code": "967",
			      "code": "YE"
			    },
			    {
			      "name": "Zambia",
			      "ISD_code": "260",
			      "code": "ZM"
			    },
			    {
			      "name": "Zimbabwe",
			      "ISD_code": "263",
			      "code": "ZW"
			    }
			  ];
